
import MarketCarousel from "../components/MarketCarousel.vue";
import MarketsList from "../components/MarketsList.vue";
export default {
  components: {
    MarketCarousel,
    MarketsList,
  },
};
